import {
    VEHICLEFINDER_RECEIVE,
    VEHICLEFINDER_ERROR,
} from '../Actions/VehicleFinder.action'
import { error as errorReducer } from './Error.reducer'

const defaultState = {
    vehicleData: {},
    errors: {},
}

export const vehicleFinder = (state = defaultState, action) => {
    const { type, payload } = action
    switch (type) {
        case VEHICLEFINDER_RECEIVE:
            return {
                ...state,
                ...payload,
            }
        case VEHICLEFINDER_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            }
        default:
            return state
    }
}
